import { toBlob, toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';

const CAPTURE_OPTIONS = { pixelRatio: 3, cacheBust: true };

export const elementToPng = async (element: HTMLElement | null) => {
  if (!element) {
    throw new Error('Element to capture is missing');
  }

  await document.fonts.ready;

  return (await toBlob(element, CAPTURE_OPTIONS)) as Blob;
};

export const elementToPdf = async (element: HTMLElement | null) => {
  if (!element) {
    throw new Error('Element to capture is missing');
  }

  await document.fonts.ready;

  const image = await toPng(element, CAPTURE_OPTIONS);
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const { pageSize } = pdf.internal;

  pdf.addImage(image, 'PNG', 0, 0, pageSize.getWidth(), pageSize.getHeight());

  return pdf.output('blob');
};
